import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/blog-post`;

export const blogPostRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:postId`,
  view: `${baseRoute}/view/:postId`,
} as const;

export type IBlogPostRouteParams = IExtractRouteParamMap<
  typeof blogPostRoutesObj
>;

export const blogPostPath = createPaths<
  typeof blogPostRoutesObj,
  IBlogPostRouteParams
>(blogPostRoutesObj);
